import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import { IActivityItemBase } from '../../models/activities';

interface ICreateActivityItemProps {
  activityId: string;
  description?: string;
  isActive: boolean;
  name: string;
  // totalAmount: number;
}

export type INewActivityItem = IActivityItemBase;

export const createActivityItemsService = async ({
  activityId,
  description,
  isActive,
  name,
}: // totalAmount,
ICreateActivityItemProps): Promise<INewActivityItem> => {
  const { data } = await jhsfBookingsApi.post<INewActivityItem>(
    `/activities/${activityId}/items`,
    {
      description,
      isActive,
      name,
      // totalAmount,
    },
  );

  return data;
};
